// SLAYER always lives on long after he's gone.
//
angular.module('dealerware.web.data').factory('WebhookModel', function ($http, Model, DataUtils) {

    'use strict';

    var dataUtils = DataUtils.getInstance();
    var baseEndpoint = '/locations/:location_id/webhooks';

    var model = new Model(
        {
            baseEndpoint: baseEndpoint,
            customActions: {
                update: {
                    method: 'PUT',
                    endpoint: baseEndpoint + '/:id',
                    ignoreAssociations: true
                },
                create: {
                    method: 'POST',
                    ignoreAssociations: true
                }
            }
        });


    angular.extend(model.prototype, {});

    return model;
});
